import { faClose } from "@fortawesome/pro-regular-svg-icons";
import { faSparkle } from "@fortawesome/pro-solid-svg-icons";
import { Chip, Stack } from "@mui/material";
import { useCallback, useMemo } from "react";
import { useLocalStorage } from "usehooks-ts";

import { Icon, IconButton, Link, Paper, Typography } from "@/components/ui-v2";

import { useChangelog } from "./useChangelog";

const DISMISSED_CHANGELOG_KEY = "lastDismissedChangelogId";

const useChangelogWidget = () => {
  const { changelogs } = useChangelog({ pageNumber: 1, pageSize: 1 });
  const [dismissedChangelogId, setDismissedChangelogId] = useLocalStorage<
    string | null
  >(DISMISSED_CHANGELOG_KEY, null);

  const latestChangelog = changelogs?.[0];

  const dismiss = useCallback(() => {
    if (!latestChangelog?.id) return;
    setDismissedChangelogId(latestChangelog.id);
  }, [latestChangelog?.id, setDismissedChangelogId]);

  return useMemo(
    () => ({
      latestChangelog:
        dismissedChangelogId !== latestChangelog?.id ? latestChangelog : null,
      dismiss,
    }),
    [latestChangelog, dismiss, dismissedChangelogId],
  );
};

export const ChangelogWidget = () => {
  const { dismiss, latestChangelog } = useChangelogWidget();

  if (!latestChangelog) return null;

  return (
    <Paper sx={{ p: 2 }}>
      <Stack>
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Chip
            label="What's New"
            icon={<Icon icon={faSparkle} size="small" />}
            sx={{
              backgroundColor: "primary.dark",
              fontSize: 12 /*Note: Chip size="small" break the icon size*/,
            }}
          />
          <IconButton
            aria-label="Hide What's New"
            variant="quaternary"
            onClick={dismiss}
          >
            <Icon icon={faClose} />
          </IconButton>
        </Stack>
        <Link href="/changelog">
          <Typography variant="small" color="textSecondary">
            {latestChangelog.description}
          </Typography>
        </Link>
      </Stack>
    </Paper>
  );
};
